import React from 'react';
import styled from 'styled-components';

interface ApplePayButtonProps {
  onClick?: () => void;
  $show?: boolean;
}

const ApplePayButton: React.FC<ApplePayButtonProps> = ({ onClick, $show }) => (
  <Container className="ap-button-container" $show={$show}>
    <button className="apple-pay-button apple-pay-button-black" onClick={onClick} />
  </Container>
);

export default ApplePayButton;

const Container = styled.div<{ $show?: boolean }>`
  display: ${(props) => (props.$show ? 'flex' : 'none')};
  align-items: center;
  height: 40px;

  @media (max-width: 768px) {
    width: 100%;
  }

  .apple-pay-button {
    border-radius: 2px;
    display: inline-block;
    height: 100%;
    width: 100%;
    // check mismatched property
    -webkit-appearance: -apple-pay-button;
    -apple-pay-button-type: 'plain';
  }

  .apple-pay-button-black {
    -apple-pay-button-style: black;
  }

  .apple-pay-button-white {
    -apple-pay-button-style: white;
  }

  .apple-pay-button-white-with-line {
    -apple-pay-button-style: white-outline;
  }
`;
